var exports = {
  "d": "x93eb46d8--77e49f--phone-number",
  "s": "x93eb46d8--77e49f--narrow",
};

module.exports = exports;
